export default new Set([
  '0-mail',
  '027168',
  '0815',
  '0sg',
  '10mail',
  '10minutemail',
  '11mail',
  '123',
  '123box',
  '123india',
  '123mail',
  '123qwe',
  '126',
  '139',
  '150mail',
  '150ml',
  '15meg4free',
  '163',
  '16mail',
  '188',
  '189',
  '1ce',
  '1chuan',
  '1coolplace',
  '1freeemail',
  '1funplace',
  '1internetdrive',
  '1mail',
  '1me',
  '1mum',
  '1musicrow',
  '1netdrive',
  '1nsyncfan',
  '1pad',
  '1under',
  '1webave',
  '1webhighway',
  '1zhuan',
  '2-mail',
  '20email',
  '20mail',
  '212',
  '21cn',
  '24horas',
  '2911',
  '2980',
  '2bmail',
  '2d2i',
  '2die4',
  '2trom',
  '3000',
  '30minutesmail',
  '3126',
  '321media',
  '33mail',
  '37',
  '3ammagazine',
  '3dmail',
  '3email',
  '3g',
  '3mail',
  '3xl',
  '444',
  '4email',
  '4mg',
  '4newyork',
  '4warding',
  '4x4man',
  '50mail',
  '60minutemail',
  '6ip',
  '6mail',
  '6paq',
  '74',
  '7mail',
  '88',
  '8848',
  '8mail',
  '97rock',
  '99experts',
  'a45',
  'aaamail',
  'aamail',
  'aapt',
  'aaronkwok',
  'abbeyroadlondon',
  'abcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyzabcdefghijk',
  'abcflash',
  'abdulnour',
  'aberystwyth',
  'about',
  'abusemail',
  'abwesend',
  'abyssmail',
  'ac20mail',
  'academycougars',
  'acceso',
  'access4less',
  'accessgcc',
  'accountant',
  'acdcfan',
  'ace-of-base',
  'acmemail',
  'acninc',
  'activist',
  'adam',
  'add3000',
  'addcom',
  'address',
  'adelphia',
  'adexec',
  'adfarrow',
  'adios',
  'adoption',
  'ados',
  'adrenalinefreak',
  'advalvas',
  'advantimo',
  'aeiou',
  'aemail4u',
  'aeneasmail',
  'afreeinternet',
  'africamail',
  'africamel',
  'ag',
  'agoodmail',
  'ahaa',
  'ahk',
  'aichi',
  'aim',
  'aircraftmail',
  'airforce',
  'airforceemail',
  'airpost',
  'ajacied',
  'ajaxapp',
  'ak47',
  'aknet',
  'albawaba',
  'alex4all',
  'alexandria',
  'algeria',
  'alhilal',
  'alibaba',
  'alice',
  'alive',
  'aliyun',
  'allergist',
  'allmail',
  'alloymail',
  'allracing',
  'allsaintsfan',
  'alpenjodel',
  'alphafrau',
  'alskens',
  'altavista',
  'alternativagratis',
  'alumni',
  'alumnidirector',
  'alvilag',
  'amail',
  'amazonses',
  'amele',
  'america',
  'ameritech',
  'amnetsal',
  'amorki',
  'amrer',
  'amuro',
  'amuromail',
  'ananzi',
  'ancestry',
  'andylau',
  'anfmail',
  'angelfire',
  'angelic',
  'animail',
  'animalhouse',
  'animalwoman',
  'anjungcafe',
  'annsmail',
  'ano-mail',
  'anonmails',
  'anonymous',
  'anote',
  'another',
  'anotherdomaincyka',
  'anotherwin95',
  'anti-social',
  'antisocial',
  'antispam24',
  'antongijsen',
  'antwerpen',
  'anymoment',
  'anytimenow',
  'aol',
  'aon',
  'apexmail',
  'apmail',
  'apollo',
  'aport',
  'aport2000',
  'appraiser',
  'approvers',
  'arabia',
  'arabtop',
  'archaeologist',
  'arcor',
  'arcotronics',
  'arcticmail',
  'argentina',
  'aristotle',
  'army',
  'armyspy',
  'arnet',
  'art-en-ligne',
  'artlover',
  'as-if',
  'asdasd',
  'asean-mail',
  'asheville',
  'asia-links',
  'asia-mail',
  'asiafind',
  'asianavenue',
  'asiancityweb',
  'asiansonly',
  'asianwired',
  'asiapoint',
  'ass',
  'assala',
  'assamesemail',
  'astroboymail',
  'astrolover',
  'astrosfan',
  'asurfer',
  'atheist',
  'athenachu',
  'atina',
  'atl',
  'atlaswebmail',
  'atmc',
  'atozasia',
  'atrus',
  'att',
  'attglobal',
  'attymail',
  'au',
  'auctioneer',
  'ausi',
  'aussiemail',
  'austin',
  'australia',
  'australiamail',
  'austrosearch',
  'autoescuelanerja',
  'autograf',
  'autorambler',
  'aver',
  'avh',
  'avia-tonic',
  'awsom',
  'axoskate',
  'ayna',
  'azazazatashkent',
  'azimiweb',
  'azmeil',
  'bachelorboy',
  'bachelorgal',
  'backpackers',
  'backstreet-boys',
  'backstreetboysclub',
  'bagherpour',
  'baldmama',
  'baldpapa',
  'ballyfinance',
  'bangkok',
  'bangkok2000',
  'bannertown',
  'baptistmail',
  'baptized',
  'barcelona',
  'bareed',
  'bartender',
  'baseballmail',
  'basketballmail',
  'batuta',
  'baudoinconsulting',
  'bboy',
  'bcvibes',
  'beddly',
  'beeebank',
  'beenhad',
  'beep',
  'beer',
  'beethoven',
  'belice',
  'belizehome',
  'bell',
  'bellair',
  'bellsouth',
  'berlin',
  'berlinexpo',
  'bestmail',
  'betriebsdirektor',
  'bettergolf',
  'bharatmail',
  'big1',
  'bigassweb',
  'bigblue',
  'bigboab',
  'bigfoot',
  'bigger',
  'biggerbadder',
  'bigmailbox',
  'bigmir',
  'bigpond',
  'bigramp',
  'bigstring',
  'bikemechanics',
  'bikeracer',
  'bikeracers',
  'bikerider',
  'billsfan',
  'bimla',
  'bin-wieder-da',
  'bio-muesli',
  'birdlover',
  'birdowner',
  'bisons',
  'bitmail',
  'bitpage',
  'bizhosting',
  'bk',
  'blackburnmail',
  'blackplanet',
  'blader',
  'bladesmail',
  'blazemail',
  'bleib-bei-mir',
  'blockfilter',
  'blogmyway',
  'bluebottle',
  'bluehyppo',
  'bluemail',
  'bluesfan',
  'bluewin',
  'blueyonder',
  'blushmail',
  'blutig',
  'bmlsports',
  'boardermail',
  'boatracers',
  'bodhi',
  'bol',
  'bolando',
  'bollywoodz',
  'boltonfans',
  'bombdiggity',
  'bonbon',
  'boom',
  'bootmail',
  'bootybay',
  'bornnaked',
  'bostonoffice',
  'boun',
  'bounce',
  'bounces',
  'bouncr',
  'box',
  'boxbg',
  'boxemail',
  'boxformail',
  'boxfrog',
  'boximail',
  'boyzoneclub',
  'bradfordfans',
  'brasilia',
  'brazilmail',
  'breadtimes',
  'breathe',
  'brennendesreich',
  'bresnan',
  'brew-master',
  'brew-meister',
  'brfree',
  'briefemail',
  'bright',
  'britneyclub',
  'brittonsign',
  'broadcast',
  'brokenvalve',
  'brusseler',
  'bsdmail',
  'btcmail',
  'btconnect',
  'btinternet',
  'btopenworld',
  'buerotiger',
  'buffymail',
  'bullsfan',
  'bullsgame',
  'bumerang',
  'bumpymail',
  'bund',
  'burnthespam',
  'burstmail',
  'buryfans',
  'business-man',
  'businessman',
  'busta-rhymes',
  'buyersusa',
  'bvimailbox',
  'byom',
  'c2',
  'c2i',
  'c3',
  'c4',
  'c51vsgq',
  'cabacabana',
  'cable',
  'cableone',
  'caere',
  'cairomail',
  'calendar-server',
  'calidifontain',
  'californiamail',
  'callnetuk',
  'callsign',
  'caltanet',
  'camidge',
  'canada-11',
  'canada',
  'canadianmail',
  'canoemail',
  'canwetalk',
  'caramail',
  'care2',
  'careerbuildermail',
  'carioca',
  'cartelera',
  'cartestraina',
  'casablancaresort',
  'casema',
  'cash4u',
  'cashette',
  'casino',
  'catcha',
  'catchamail',
  'catholic',
  'catlover',
  'cd2',
  'celineclub',
  'celtic',
  'center-mail',
  'centermail',
  'centoper',
  'centralpets',
  'centrum',
  'centurytel',
  'certifiedmail',
  'cfl',
  'cgac',
  'cghost',
  'chacuo',
  'chaiyomail',
  'chammy',
  'chance2mail',
  'chandrasekar',
  'charmedmail',
  'charter',
  'chat',
  'chattown',
  'chauhanweb',
  'cheatmail',
  'chechnya',
  'check',
  'check1check',
  'cheerful',
  'chef',
  'chek',
  'chello',
  'chemist',
  'chequemail',
  'cheyenneweb',
  'chez',
  'chickmail',
  'china',
  'chinamail',
  'chirk',
  'chocaholic',
  'chong-mail',
  'churchusa',
  'cia-agent',
  'cia',
  'ciaoweb',
  'cicciociccio',
  'cincinow',
  'citiz',
  'citlink',
  'city-of-bath',
  'city-of-birmingham',
  'city-of-brighton',
  'city-of-cambridge',
  'city-of-coventry',
  'city-of-edinburgh',
  'city-of-lichfield',
  'city-of-lincoln',
  'city-of-liverpool',
  'city-of-manchester',
  'city-of-nottingham',
  'city-of-oxford',
  'city-of-swansea',
  'city-of-westminster',
  'city-of-york',
  'cityofcardiff',
  'cityoflondon',
  'ckaazaza',
  'claramail',
  'classicalfan',
  'classicmail',
  'clear',
  'clearwire',
  'clerk',
  'cliffhanger',
  'clixser',
  'close2you',
  'clrmail',
  'club4x4',
  'clubalfa',
  'clubbers',
  'clubducati',
  'clubhonda',
  'clubmember',
  'clubnetnoir',
  'clubvdo',
  'cluemail',
  'cmail',
  'cmpmail',
  'cnnsimail',
  'cntv',
  'codec',
  'coder',
  'coid',
  'coldmail',
  'collectiblesuperstore',
  'collector',
  'collegeclub',
  'collegemail',
  'colleges',
  'columbus',
  'columbusrr',
  'columnist',
  'comcast',
  'comic',
  'communityconnect',
  'comporium',
  'comprendemail',
  'compuserve',
  'computer-freak',
  'computer4u',
  'computermail',
  'conexcol',
  'conk',
  'connect4free',
  'connectbox',
  'consultant',
  'consumerriot',
  'contractor',
  'contrasto',
  'cookiemonster',
  'cool',
  'coole-files',
  'coolgoose',
  'coolkiwi',
  'coollist',
  'coolmail',
  'coolsend',
  'coolsite',
  'cooooool',
  'cooperation',
  'cooperationtogo',
  'copacabana',
  'copper',
  'cornells',
  'cornerpub',
  'corporatedirtbag',
  'correo',
  'cortinet',
  'cotas',
  'counsellor',
  'countrylover',
  'cox',
  'coxinet',
  'cracker',
  'crapmail',
  'crazedanddazed',
  'crazymailing',
  'crazysexycool',
  'cristianemail',
  'critterpost',
  'croeso',
  'crosshairs',
  'crosswinds',
  'crwmail',
  'cry4helponline',
  'cs',
  'csinibaba',
  'cuemail',
  'curio-city',
  'curryworld',
  'cute-girl',
  'cuteandcuddly',
  'cutey',
  'cww',
  'cyber-africa',
  'cyber-innovation',
  'cyber-matrix',
  'cyber-phone',
  'cyber-wizard',
  'cyber4all',
  'cyberbabies',
  'cybercafemaui',
  'cyberdude',
  'cyberforeplay',
  'cybergal',
  'cybergrrl',
  'cyberinbox',
  'cyberleports',
  'cybermail',
  'cybernet',
  'cyberservices',
  'cyberspace-asia',
  'cybertrains',
  'cyclefanz',
  'cynetcity',
  'dabsol',
  'dadacasa',
  'daha',
  'dailypioneer',
  'dallasmail',
  'dangerous-minds',
  'dansegulvet',
  'dasdasdascyka',
  'data54',
  'davegracey',
  'dawnsonmail',
  'dawsonmail',
  'dazedandconfused',
  'dbzmail',
  'dcemail',
  'deadlymob',
  'deagot',
  'deal-maker',
  'dearriba',
  'death-star',
  'deliveryman',
  'deneg',
  'depechemode',
  'deseretmail',
  'desertmail',
  'desilota',
  'deskpilot',
  'destin',
  'detik',
  'deutschland-net',
  'devotedcouples',
  'dezigner',
  'dfwatson',
  'di-ve',
  'die-besten-bilder',
  'die-genossen',
  'die-optimisten',
  'diemailbox',
  'digibel',
  'digital-filestore',
  'diplomats',
  'directbox',
  'dirtracer',
  'discard',
  'disciples',
  'discofan',
  'discoverymail',
  'disign-concept',
  'disign-revelation',
  'disinfo',
  'dispomail',
  'disposable',
  'dispose',
  'dm',
  'dmailman',
  'dnainternet',
  'dnsmadeeasy',
  'doclist',
  'docmail',
  'docs',
  'doctor',
  'dodgit',
  'dodo',
  'dodsi',
  'dog',
  'dogit',
  'doglover',
  'dogmail',
  'dogsnob',
  'doityourself',
  'domforfb1',
  'domforfb2',
  'domforfb3',
  'domforfb4',
  'domforfb5',
  'domforfb6',
  'domforfb7',
  'domforfb8',
  'domozmail',
  'doneasy',
  'donjuan',
  'dontgotmail',
  'dontmesswithtexas',
  'doramail',
  'dostmail',
  'dotcom',
  'dotmsg',
  'dott',
  'download-privat',
  'dplanet',
  'dr',
  'dragoncon',
  'dropmail',
  'dropzone',
  'drotposta',
  'dubaimail',
  'dublin',
  'dumpmail',
  'dumpyemail',
  'dunlopdriver',
  'dunloprider',
  'duno',
  'duskmail',
  'dutchmail',
  'dwp',
  'dygo',
  'dynamitemail',
  'dyndns',
  'e-apollo',
  'e-mail',
  'e-mailanywhere',
  'e-mails',
  'e-tapaal',
  'earthalliance',
  'earthcam',
  'earthdome',
  'earthling',
  'earthlink',
  'earthonline',
  'eastcoast',
  'eastmail',
  'easy',
  'easypost',
  'easytrashmail',
  'ec',
  'ecardmail',
  'ecbsolutions',
  'echina',
  'ecolo-online',
  'ecompare',
  'edmail',
  'ednatx',
  'edtnmail',
  'educacao',
  'eelmail',
  'ehmail',
  'einrot',
  'eintagsmail',
  'eircom',
  'elisanet',
  'elitemail',
  'elsitio',
  'elvis',
  'elvisfan',
  'email-fake',
  'email-london',
  'email',
  'email2me',
  'email4u',
  'emailacc',
  'emailaccount',
  'emailage',
  'emailasso',
  'emailchoice',
  'emailcorner',
  'emailem',
  'emailengine',
  'emailer',
  'emailforyou',
  'emailgo',
  'emailgroups',
  'emailinfive',
  'emailit',
  'emailpinoy',
  'emailplanet',
  'emailplus',
  'emailproxsy',
  'emails',
  'emailthe',
  'emailto',
  'emailuser',
  'emailx',
  'emailz',
  'ematic',
  'embarqmail',
  'emeil',
  'emil',
  'eml',
  'end-war',
  'enel',
  'engineer',
  'england',
  'englandmail',
  'epage',
  'epatra',
  'ephemail',
  'epix',
  'epost',
  'eposta',
  'eqqu',
  'eramail',
  'eresmas',
  'eriga',
  'estranet',
  'ethos',
  'etoast',
  'etrademail',
  'etranquil',
  'eudoramail',
  'europamel',
  'europe',
  'europemail',
  'euroseek',
  'eurosport',
  'every1',
  'everyday',
  'everymail',
  'everyone',
  'everytg',
  'examnotes',
  'excite',
  'execs',
  'exemail',
  'exg6',
  'existiert',
  'expressasia',
  'extenda',
  'extended',
  'eyepaste',
  'eyou',
  'ezcybersearch',
  'ezmail',
  'ezrs',
  'f-m',
  'f1fans',
  'facebook-email',
  'facebook',
  'facebookmail',
  'fahr-zur-hoelle',
  'fake-email',
  'fake-mail',
  'fakemailz',
  'falseaddress',
  'fan',
  'fansonlymail',
  'fansworldwide',
  'fantasticmail',
  'farang',
  'farifluset',
  'faroweb',
  'fast-email',
  'fast-mail',
  'fastacura',
  'fastchevy',
  'fastchrysler',
  'fastem',
  'fastemail',
  'fastemailer',
  'fastermail',
  'fastest',
  'fastimap',
  'fastkawasaki',
  'fastmail',
  'fastmailbox',
  'fastmazda',
  'fastmessaging',
  'fastmitsubishi',
  'fastnissan',
  'fastservice',
  'fastsubaru',
  'fastsuzuki',
  'fasttoyota',
  'fastyamaha',
  'fatcock',
  'fatflap',
  'fathersrightsne',
  'fax',
  'fbi-agent',
  'fbi',
  'fdfdsfds',
  'fea',
  'federalcontractors',
  'feinripptraeger',
  'felicitymail',
  'femenino',
  'fetchmail',
  'fettabernett',
  'feyenoorder',
  'ffanet',
  'fiberia',
  'ficken',
  'fightallspam',
  'filipinolinks',
  'financemail',
  'financier',
  'findmail',
  'finebody',
  'fire-brigade',
  'fireman',
  'fishburne',
  'fishfuse',
  'fixmail',
  'fizmail',
  'flashbox',
  'flashmail',
  'fleckens',
  'flipcode',
  'fmail',
  'fmailbox',
  'fmgirl',
  'fmguy',
  'fnbmail',
  'fnmail',
  'folkfan',
  'foodmail',
  'footard',
  'footballmail',
  'foothills',
  'for-president',
  'force9',
  'forfree',
  'forgetmail',
  'fornow',
  'forpresident',
  'fortuncity',
  'fortunecity',
  'forum',
  'foxmail',
  'fr33mail',
  'francemel',
  'free-email',
  'free-online',
  'free-org',
  'free',
  'freeaccess',
  'freeaccount',
  'freeandsingle',
  'freedom',
  'freedomlover',
  'freegates',
  'freeghana',
  'freelance-france',
  'freeler',
  'freemail',
  'freemails',
  'freemeil',
  'freenet',
  'freeola',
  'freeserve',
  'freestart',
  'freesurf',
  'freeuk',
  'freeukisp',
  'freeweb',
  'freewebemail',
  'freeyellow',
  'freezone',
  'fresnomail',
  'freudenkinder',
  'freundin',
  'friendlymail',
  'friends-cafe',
  'friendsfan',
  'from-africa',
  'from-america',
  'from-argentina',
  'from-asia',
  'from-australia',
  'from-belgium',
  'from-brazil',
  'from-canada',
  'from-china',
  'from-england',
  'from-europe',
  'from-france',
  'from-germany',
  'from-holland',
  'from-israel',
  'from-italy',
  'from-japan',
  'from-korea',
  'from-mexico',
  'from-outerspace',
  'from-russia',
  'from-spain',
  'fromalabama',
  'fromalaska',
  'fromarizona',
  'fromarkansas',
  'fromcalifornia',
  'fromcolorado',
  'fromconnecticut',
  'fromdelaware',
  'fromflorida',
  'fromgeorgia',
  'fromhawaii',
  'fromidaho',
  'fromillinois',
  'fromindiana',
  'fromiowa',
  'fromjupiter',
  'fromkansas',
  'fromkentucky',
  'fromlouisiana',
  'frommaine',
  'frommaryland',
  'frommassachusetts',
  'frommiami',
  'frommichigan',
  'fromminnesota',
  'frommississippi',
  'frommissouri',
  'frommontana',
  'fromnebraska',
  'fromnevada',
  'fromnewhampshire',
  'fromnewjersey',
  'fromnewmexico',
  'fromnewyork',
  'fromnorthcarolina',
  'fromnorthdakota',
  'fromohio',
  'fromoklahoma',
  'fromoregon',
  'frompennsylvania',
  'fromrhodeisland',
  'fromru',
  'fromsouthcarolina',
  'fromsouthdakota',
  'fromtennessee',
  'fromtexas',
  'fromthestates',
  'fromutah',
  'fromvermont',
  'fromvirginia',
  'fromwashington',
  'fromwashingtondc',
  'fromwestvirginia',
  'fromwisconsin',
  'fromwyoming',
  'front',
  'frontier',
  'frontiernet',
  'frostbyte',
  'fsmail',
  'ftc-i',
  'ftml',
  'fullmail',
  'funkfan',
  'fuorissimo',
  'furnitureprovider',
  'fuse',
  'fut',
  'fux0ringduh',
  'fwnb',
  'fxsmails',
  'galaxy5',
  'galaxyhit',
  'gamebox',
  'gamegeek',
  'gamespotmail',
  'gamno',
  'garbage',
  'gardener',
  'gawab',
  'gaybrighton',
  'gaza',
  'gazeta',
  'gazibooks',
  'gci',
  'geecities',
  'geek',
  'geeklife',
  'gelitik',
  'gencmail',
  'general-hospital',
  'gentlemansclub',
  'geocities',
  'geography',
  'geologist',
  'geopia',
  'germanymail',
  'get',
  'get1mail',
  'getairmail',
  'getonemail',
  'ghanamail',
  'ghostmail',
  'ghosttexter',
  'giga4u',
  'gigileung',
  'girl4god',
  'givepeaceachance',
  'glay',
  'glendale',
  'globalfree',
  'globalpagan',
  'globalsite',
  'gmail',
  'gmx',
  'go',
  'go2net',
  'gocollege',
  'gocubs',
  'goemailgo',
  'gofree',
  'gol',
  'goldenmail',
  'goldmail',
  'goldtoolbox',
  'golfemail',
  'golfilla',
  'golfmail',
  'gonavy',
  'goodnewsmail',
  'goodstick',
  'googlegroups',
  'googlemail',
  'goplay',
  'gorillaswithdirtyarmpits',
  'gorontalo',
  'gospelfan',
  'gothere',
  'gotmail',
  'gotomy',
  'gotti',
  'gportal',
  'graduate',
  'graffiti',
  'gramszu',
  'grandmamail',
  'grandmasmail',
  'graphic-designer',
  'grapplers',
  'gratisweb',
  'greenmail',
  'groupmail',
  'grr',
  'grungecafe',
  'gtmc',
  'gua',
  'guessmail',
  'guju',
  'gustr',
  'guy',
  'guy2',
  'guyanafriends',
  'gyorsposta',
  'h-mail',
  'hab-verschlafen',
  'habmalnefrage',
  'hacccc',
  'hackermail',
  'hailmail',
  'hairdresser',
  'hamptonroads',
  'handbag',
  'handleit',
  'hang-ten',
  'hanmail',
  'happemail',
  'happycounsel',
  'happypuppy',
  'harakirimail',
  'hardcorefreak',
  'hartbot',
  'hawaii',
  'hawaiiantel',
  'heartthrob',
  'heerschap',
  'heesun',
  'hehe',
  'hello',
  'helter-skelter',
  'herediano',
  'herono1',
  'herp',
  'herr-der-mails',
  'hetnet',
  'hey',
  'hhdevel',
  'hidzz',
  'highmilton',
  'highquality',
  'highveldmail',
  'hilarious',
  'hiphopfan',
  'hispavista',
  'hitmail',
  'hitthe',
  'hkg',
  'hkstarphoto',
  'hockeymail',
  'hollywoodkids',
  'home-email',
  'home',
  'homelocator',
  'homemail',
  'homestead',
  'honduras',
  'hongkong',
  'hookup',
  'hoopsmail',
  'hopemail',
  'horrormail',
  'hot-mail',
  'hot-shot',
  'hot',
  'hotbot',
  'hotbrev',
  'hotfire',
  'hotletter',
  'hotmail',
  'hotpop',
  'hotpop3',
  'hotvoice',
  'housemail',
  'hsuchi',
  'hu2',
  'hughes',
  'humanoid',
  'humn',
  'hunsa',
  'hurting',
  'hush',
  'hushmail',
  'hypernautica',
  'i-connect',
  'i-france',
  'i-mail',
  'i-p',
  'i',
  'i12',
  'i2pmail',
  'iamawoman',
  'iamwaiting',
  'iamwasted',
  'iamyours',
  'icestorm',
  'ich-bin-verrueckt-nach-dir',
  'ich-will-net',
  'icloud',
  'icmsconsultants',
  'icq',
  'icqmail',
  'icrazy',
  'id-base',
  'ididitmyway',
  'idigjesus',
  'idirect',
  'ieatspam',
  'ieh-mail',
  'iespana',
  'ifoward',
  'ig',
  'ignazio',
  'ignmail',
  'ihateclowns',
  'ihateyoualot',
  'iheartspam',
  'iinet',
  'ijustdontcare',
  'ikbenspamvrij',
  'ilkposta',
  'ilovechocolate',
  'ilovejesus',
  'ilovetocollect',
  'ilse',
  'imaginemail',
  'imail',
  'imailbox',
  'imap-mail',
  'imap',
  'imapmail',
  'imel',
  'imgof',
  'imgv',
  'immo-gerance',
  'imneverwrong',
  'imposter',
  'imstations',
  'imstressed',
  'imtoosexy',
  'in-box',
  'in2jesus',
  'iname',
  'inbax',
  'inbound',
  'inbox',
  'inboxalias',
  'incamail',
  'incredimail',
  'indeedemail',
  'index',
  'indexa',
  'india',
  'indiatimes',
  'indo-mail',
  'indocities',
  'indomail',
  'indyracers',
  'inerted',
  'inet',
  'info-media',
  'info-radio',
  'info66',
  'infohq',
  'infomail',
  'infomart',
  'infospacemail',
  'infovia',
  'inicia',
  'inmail',
  'inmail24',
  'inmano',
  'inmynetwork',
  'innocent',
  'inorbit',
  'inoutbox',
  'insidebaltimore',
  'insight',
  'instant-mail',
  'instantemailaddress',
  'instantmail',
  'instruction',
  'instructor',
  'insurer',
  'interburp',
  'interfree',
  'interia',
  'interlap',
  'intermail',
  'internet-e-mail',
  'internet-mail',
  'internet-police',
  'internetbiz',
  'internetdrive',
  'internetegypt',
  'internetemails',
  'internetmailing',
  'internode',
  'invalid',
  'inwind',
  'iobox',
  'iol',
  'iowaemail',
  'ip3',
  'ip4',
  'ip6',
  'ipoo',
  'iprimus',
  'iqemail',
  'irangate',
  'iraqmail',
  'ireland',
  'irelandmail',
  'iremail',
  'irj',
  'iroid',
  'isellcars',
  'iservejesus',
  'islamonline',
  'isleuthmail',
  'ismart',
  'isonfire',
  'isp9',
  'israelmail',
  'ist-allein',
  'ist-einmalig',
  'ist-ganz-allein',
  'ist-willig',
  'italymail',
  'itloox',
  'itmom',
  'ivebeenframed',
  'ivillage',
  'iwan-fals',
  'iwmail',
  'iwon',
  'izadpanah',
  'jahoopa',
  'jakuza',
  'japan',
  'jaydemail',
  'jazzandjava',
  'jazzfan',
  'jazzgame',
  'je-recycle',
  'jerusalemmail',
  'jet-renovation',
  'jetable',
  'jetemail',
  'jippii',
  'jmail',
  'job4u',
  'jobbikszimpatizans',
  'joelonsoftware',
  'joinme',
  'jokes',
  'jordanmail',
  'journalist',
  'jourrapide',
  'jovem',
  'joymail',
  'jpopmail',
  'jsrsolutions',
  'jubiimail',
  'jump',
  'jumpy',
  'juniormail',
  'junk1e',
  'junkmail',
  'juno',
  'justemail',
  'justicemail',
  'kaazoo',
  'kaffeeschluerfer',
  'kaixo',
  'kalpoint',
  'kansascity',
  'kapoorweb',
  'karachian',
  'karachioye',
  'karbasi',
  'katamail',
  'kayafmmail',
  'kbjrmail',
  'kcks',
  'keg-party',
  'keinpardon',
  'keko',
  'kellychen',
  'keromail',
  'keyemail',
  'kgb',
  'khosropour',
  'kickassmail',
  'killermail',
  'kimo',
  'kimsdisk',
  'kinglibrary',
  'kinki-kids',
  'kissfans',
  'kittymail',
  'kitznet',
  'kiwibox',
  'kiwitown',
  'klassmaster',
  'km',
  'knol-power',
  'kolumbus',
  'kommespaeter',
  'konx',
  'korea',
  'koreamail',
  'kpnmail',
  'krim',
  'krongthip',
  'krunis',
  'ksanmail',
  'ksee24mail',
  'kube93mail',
  'kukamail',
  'kulturbetrieb',
  'kumarweb',
  'kuwait-mail',
  'l33r',
  'la',
  'labetteraverouge',
  'ladymail',
  'lagerlouts',
  'lags',
  'lahoreoye',
  'lakmail',
  'lamer',
  'land',
  'lankamail',
  'laoeq',
  'laposte',
  'lass-es-geschehen',
  'last-chance',
  'lastmail',
  'latemodels',
  'latinmail',
  'lavache',
  'law',
  'lawyer',
  'lazyinbox',
  'leehom',
  'legalactions',
  'legalrc',
  'legislator',
  'lenta',
  'leonlai',
  'letsgomets',
  'letterboxes',
  'letthemeatspam',
  'levele',
  'lex',
  'lexis-nexis-mail',
  'libero',
  'liberomail',
  'lick101',
  'liebt-dich',
  'linkmaster',
  'linktrader',
  'linuxfreemail',
  'linuxmail',
  'lionsfan',
  'liontrucks',
  'liquidinformation',
  'list',
  'listomail',
  'littleapple',
  'littleblueroom',
  'live',
  'liveradio',
  'liverpoolfans',
  'llandudno',
  'llangollen',
  'lmxmail',
  'lobbyist',
  'localbar',
  'locos',
  'login-email',
  'loh',
  'lolfreak',
  'lolito',
  'london',
  'looksmart',
  'lopezclub',
  'louiskoo',
  'love',
  'loveable',
  'lovecat',
  'lovefall',
  'lovefootball',
  'lovelygirl',
  'lovemail',
  'lover-boy',
  'lovergirl',
  'lovesea',
  'lovethebroncos',
  'lovethecowboys',
  'loveyouforever',
  'lovingjesus',
  'lowandslow',
  'lr7',
  'lroid',
  'luso',
  'luukku',
  'luv2',
  'lvie',
  'lycos',
  'lycosmail',
  'm-a-i-l',
  'm-hmail',
  'm4',
  'm4ilweb',
  'mac',
  'macbox',
  'macfreak',
  'machinecandy',
  'macmail',
  'madcreations',
  'madonnafan',
  'madrid',
  'maennerversteherin',
  'maffia',
  'magicmail',
  'magspam',
  'mahmoodweb',
  'mail',
  'mail-awu',
  'mail-box',
  'mail-center',
  'mail-central',
  'mail-easy',
  'mail-filter',
  'mail-me',
  'mail-page',
  'mail-tester',
  'mail114',
  'mail15',
  'mail2007',
  'mail2aaron',
  'mail2abby',
  'mail2abc',
  'mail2actor',
  'mail2admiral',
  'mail2adorable',
  'mail2adoration',
  'mail2adore',
  'mail2adventure',
  'mail2aeolus',
  'mail2aether',
  'mail2affection',
  'mail2afghanistan',
  'mail2africa',
  'mail2agent',
  'mail2aha',
  'mail2ahoy',
  'mail2aim',
  'mail2air',
  'mail2airbag',
  'mail2airforce',
  'mail2airport',
  'mail2alabama',
  'mail2alan',
  'mail2alaska',
  'mail2albania',
  'mail2alcoholic',
  'mail2alec',
  'mail2alexa',
  'mail2algeria',
  'mail2alicia',
  'mail2alien',
  'mail2allan',
  'mail2allen',
  'mail2allison',
  'mail2alpha',
  'mail2alyssa',
  'mail2amanda',
  'mail2amazing',
  'mail2amber',
  'mail2america',
  'mail2american',
  'mail2andorra',
  'mail2andrea',
  'mail2andy',
  'mail2anesthesiologist',
  'mail2angela',
  'mail2angola',
  'mail2ann',
  'mail2anna',
  'mail2anne',
  'mail2anthony',
  'mail2anything',
  'mail2aphrodite',
  'mail2apollo',
  'mail2april',
  'mail2aquarius',
  'mail2arabia',
  'mail2arabic',
  'mail2architect',
  'mail2ares',
  'mail2argentina',
  'mail2aries',
  'mail2arizona',
  'mail2arkansas',
  'mail2armenia',
  'mail2army',
  'mail2arnold',
  'mail2art',
  'mail2artemus',
  'mail2arthur',
  'mail2artist',
  'mail2ashley',
  'mail2ask',
  'mail2astronomer',
  'mail2athena',
  'mail2athlete',
  'mail2atlas',
  'mail2atom',
  'mail2attitude',
  'mail2auction',
  'mail2aunt',
  'mail2australia',
  'mail2austria',
  'mail2azerbaijan',
  'mail2baby',
  'mail2bahamas',
  'mail2bahrain',
  'mail2ballerina',
  'mail2ballplayer',
  'mail2band',
  'mail2bangladesh',
  'mail2bank',
  'mail2banker',
  'mail2bankrupt',
  'mail2baptist',
  'mail2bar',
  'mail2barbados',
  'mail2barbara',
  'mail2barter',
  'mail2basketball',
  'mail2batter',
  'mail2beach',
  'mail2beast',
  'mail2beatles',
  'mail2beauty',
  'mail2becky',
  'mail2beijing',
  'mail2belgium',
  'mail2belize',
  'mail2ben',
  'mail2bernard',
  'mail2beth',
  'mail2betty',
  'mail2beverly',
  'mail2beyond',
  'mail2biker',
  'mail2bill',
  'mail2billionaire',
  'mail2billy',
  'mail2bio',
  'mail2biologist',
  'mail2black',
  'mail2blackbelt',
  'mail2blake',
  'mail2blind',
  'mail2blonde',
  'mail2blues',
  'mail2bob',
  'mail2bobby',
  'mail2bolivia',
  'mail2bombay',
  'mail2bonn',
  'mail2bookmark',
  'mail2boreas',
  'mail2bosnia',
  'mail2boston',
  'mail2botswana',
  'mail2bradley',
  'mail2brazil',
  'mail2breakfast',
  'mail2brian',
  'mail2bride',
  'mail2brittany',
  'mail2broker',
  'mail2brook',
  'mail2bruce',
  'mail2brunei',
  'mail2brunette',
  'mail2brussels',
  'mail2bryan',
  'mail2bug',
  'mail2bulgaria',
  'mail2business',
  'mail2buy',
  'mail2ca',
  'mail2california',
  'mail2calvin',
  'mail2cambodia',
  'mail2cameroon',
  'mail2canada',
  'mail2cancer',
  'mail2capeverde',
  'mail2capricorn',
  'mail2cardinal',
  'mail2cardiologist',
  'mail2care',
  'mail2caroline',
  'mail2carolyn',
  'mail2casey',
  'mail2cat',
  'mail2caterer',
  'mail2cathy',
  'mail2catlover',
  'mail2catwalk',
  'mail2cell',
  'mail2chad',
  'mail2champaign',
  'mail2charles',
  'mail2chef',
  'mail2chemist',
  'mail2cherry',
  'mail2chicago',
  'mail2chile',
  'mail2china',
  'mail2chinese',
  'mail2chocolate',
  'mail2christian',
  'mail2christie',
  'mail2christmas',
  'mail2christy',
  'mail2chuck',
  'mail2cindy',
  'mail2clark',
  'mail2classifieds',
  'mail2claude',
  'mail2cliff',
  'mail2clinic',
  'mail2clint',
  'mail2close',
  'mail2club',
  'mail2coach',
  'mail2coastguard',
  'mail2colin',
  'mail2college',
  'mail2colombia',
  'mail2color',
  'mail2colorado',
  'mail2columbia',
  'mail2comedian',
  'mail2composer',
  'mail2computer',
  'mail2computers',
  'mail2concert',
  'mail2congo',
  'mail2connect',
  'mail2connecticut',
  'mail2consultant',
  'mail2convict',
  'mail2cook',
  'mail2cool',
  'mail2cory',
  'mail2costarica',
  'mail2country',
  'mail2courtney',
  'mail2cowboy',
  'mail2cowgirl',
  'mail2craig',
  'mail2crave',
  'mail2crazy',
  'mail2create',
  'mail2croatia',
  'mail2cry',
  'mail2crystal',
  'mail2cuba',
  'mail2culture',
  'mail2curt',
  'mail2customs',
  'mail2cute',
  'mail2cutey',
  'mail2cynthia',
  'mail2cyprus',
  'mail2czechrepublic',
  'mail2dad',
  'mail2dale',
  'mail2dallas',
  'mail2dan',
  'mail2dana',
  'mail2dance',
  'mail2dancer',
  'mail2danielle',
  'mail2danny',
  'mail2darlene',
  'mail2darling',
  'mail2darren',
  'mail2daughter',
  'mail2dave',
  'mail2dawn',
  'mail2dc',
  'mail2dealer',
  'mail2deanna',
  'mail2dearest',
  'mail2debbie',
  'mail2debby',
  'mail2deer',
  'mail2delaware',
  'mail2delicious',
  'mail2demeter',
  'mail2democrat',
  'mail2denise',
  'mail2denmark',
  'mail2dennis',
  'mail2dentist',
  'mail2derek',
  'mail2desert',
  'mail2devoted',
  'mail2devotion',
  'mail2diamond',
  'mail2diana',
  'mail2diane',
  'mail2diehard',
  'mail2dilemma',
  'mail2dillon',
  'mail2dinner',
  'mail2dinosaur',
  'mail2dionysos',
  'mail2diplomat',
  'mail2director',
  'mail2dirk',
  'mail2disco',
  'mail2dive',
  'mail2diver',
  'mail2divorced',
  'mail2djibouti',
  'mail2doctor',
  'mail2doglover',
  'mail2dominic',
  'mail2dominica',
  'mail2dominicanrepublic',
  'mail2don',
  'mail2donald',
  'mail2donna',
  'mail2doris',
  'mail2dorothy',
  'mail2doug',
  'mail2dough',
  'mail2douglas',
  'mail2dow',
  'mail2downtown',
  'mail2dream',
  'mail2dreamer',
  'mail2dude',
  'mail2dustin',
  'mail2dyke',
  'mail2dylan',
  'mail2earl',
  'mail2earth',
  'mail2eastend',
  'mail2eat',
  'mail2economist',
  'mail2ecuador',
  'mail2eddie',
  'mail2edgar',
  'mail2edwin',
  'mail2egypt',
  'mail2electron',
  'mail2eli',
  'mail2elizabeth',
  'mail2ellen',
  'mail2elliot',
  'mail2elsalvador',
  'mail2elvis',
  'mail2emergency',
  'mail2emily',
  'mail2engineer',
  'mail2english',
  'mail2environmentalist',
  'mail2eos',
  'mail2eric',
  'mail2erica',
  'mail2erin',
  'mail2erinyes',
  'mail2eris',
  'mail2eritrea',
  'mail2ernie',
  'mail2eros',
  'mail2estonia',
  'mail2ethan',
  'mail2ethiopia',
  'mail2eu',
  'mail2europe',
  'mail2eurus',
  'mail2eva',
  'mail2evan',
  'mail2evelyn',
  'mail2everything',
  'mail2exciting',
  'mail2expert',
  'mail2fairy',
  'mail2faith',
  'mail2fanatic',
  'mail2fancy',
  'mail2fantasy',
  'mail2farm',
  'mail2farmer',
  'mail2fashion',
  'mail2fat',
  'mail2feeling',
  'mail2female',
  'mail2fever',
  'mail2fighter',
  'mail2fiji',
  'mail2filmfestival',
  'mail2films',
  'mail2finance',
  'mail2finland',
  'mail2fireman',
  'mail2firm',
  'mail2fisherman',
  'mail2flexible',
  'mail2florence',
  'mail2florida',
  'mail2floyd',
  'mail2fly',
  'mail2fond',
  'mail2fondness',
  'mail2football',
  'mail2footballfan',
  'mail2found',
  'mail2france',
  'mail2frank',
  'mail2frankfurt',
  'mail2franklin',
  'mail2fred',
  'mail2freddie',
  'mail2free',
  'mail2freedom',
  'mail2french',
  'mail2freudian',
  'mail2friendship',
  'mail2from',
  'mail2fun',
  'mail2gabon',
  'mail2gabriel',
  'mail2gail',
  'mail2galaxy',
  'mail2gambia',
  'mail2games',
  'mail2gary',
  'mail2gavin',
  'mail2gemini',
  'mail2gene',
  'mail2genes',
  'mail2geneva',
  'mail2george',
  'mail2georgia',
  'mail2gerald',
  'mail2german',
  'mail2germany',
  'mail2ghana',
  'mail2gilbert',
  'mail2gina',
  'mail2girl',
  'mail2glen',
  'mail2gloria',
  'mail2goddess',
  'mail2gold',
  'mail2golfclub',
  'mail2golfer',
  'mail2gordon',
  'mail2government',
  'mail2grab',
  'mail2grace',
  'mail2graham',
  'mail2grandma',
  'mail2grandpa',
  'mail2grant',
  'mail2greece',
  'mail2green',
  'mail2greg',
  'mail2grenada',
  'mail2gsm',
  'mail2guard',
  'mail2guatemala',
  'mail2guy',
  'mail2hades',
  'mail2haiti',
  'mail2hal',
  'mail2handhelds',
  'mail2hank',
  'mail2hannah',
  'mail2harold',
  'mail2harry',
  'mail2hawaii',
  'mail2headhunter',
  'mail2heal',
  'mail2heather',
  'mail2heaven',
  'mail2hebe',
  'mail2hecate',
  'mail2heidi',
  'mail2helen',
  'mail2hell',
  'mail2help',
  'mail2helpdesk',
  'mail2henry',
  'mail2hephaestus',
  'mail2hera',
  'mail2hercules',
  'mail2herman',
  'mail2hermes',
  'mail2hespera',
  'mail2hestia',
  'mail2highschool',
  'mail2hindu',
  'mail2hip',
  'mail2hiphop',
  'mail2holland',
  'mail2holly',
  'mail2hollywood',
  'mail2homer',
  'mail2honduras',
  'mail2honey',
  'mail2hongkong',
  'mail2hope',
  'mail2horse',
  'mail2hot',
  'mail2hotel',
  'mail2houston',
  'mail2howard',
  'mail2hugh',
  'mail2human',
  'mail2hungary',
  'mail2hungry',
  'mail2hygeia',
  'mail2hyperspace',
  'mail2hypnos',
  'mail2ian',
  'mail2ice-cream',
  'mail2iceland',
  'mail2idaho',
  'mail2idontknow',
  'mail2illinois',
  'mail2imam',
  'mail2in',
  'mail2india',
  'mail2indian',
  'mail2indiana',
  'mail2indonesia',
  'mail2infinity',
  'mail2intense',
  'mail2iowa',
  'mail2iran',
  'mail2iraq',
  'mail2ireland',
  'mail2irene',
  'mail2iris',
  'mail2irresistible',
  'mail2irving',
  'mail2irwin',
  'mail2isaac',
  'mail2israel',
  'mail2italian',
  'mail2italy',
  'mail2jackie',
  'mail2jacob',
  'mail2jail',
  'mail2jaime',
  'mail2jake',
  'mail2jamaica',
  'mail2james',
  'mail2jamie',
  'mail2jan',
  'mail2jane',
  'mail2janet',
  'mail2janice',
  'mail2japan',
  'mail2japanese',
  'mail2jasmine',
  'mail2jason',
  'mail2java',
  'mail2jay',
  'mail2jazz',
  'mail2jed',
  'mail2jeffrey',
  'mail2jennifer',
  'mail2jenny',
  'mail2jeremy',
  'mail2jerry',
  'mail2jessica',
  'mail2jessie',
  'mail2jesus',
  'mail2jew',
  'mail2jeweler',
  'mail2jim',
  'mail2jimmy',
  'mail2joan',
  'mail2joann',
  'mail2joanna',
  'mail2jody',
  'mail2joe',
  'mail2joel',
  'mail2joey',
  'mail2john',
  'mail2join',
  'mail2jon',
  'mail2jonathan',
  'mail2jones',
  'mail2jordan',
  'mail2joseph',
  'mail2josh',
  'mail2joy',
  'mail2juan',
  'mail2judge',
  'mail2judy',
  'mail2juggler',
  'mail2julian',
  'mail2julie',
  'mail2jumbo',
  'mail2junk',
  'mail2justin',
  'mail2justme',
  'mail2k',
  'mail2kansas',
  'mail2karate',
  'mail2karen',
  'mail2karl',
  'mail2karma',
  'mail2kathleen',
  'mail2kathy',
  'mail2katie',
  'mail2kay',
  'mail2kazakhstan',
  'mail2keen',
  'mail2keith',
  'mail2kelly',
  'mail2kelsey',
  'mail2ken',
  'mail2kendall',
  'mail2kennedy',
  'mail2kenneth',
  'mail2kenny',
  'mail2kentucky',
  'mail2kenya',
  'mail2kerry',
  'mail2kevin',
  'mail2kim',
  'mail2kimberly',
  'mail2king',
  'mail2kirk',
  'mail2kiss',
  'mail2kosher',
  'mail2kristin',
  'mail2kurt',
  'mail2kuwait',
  'mail2kyle',
  'mail2kyrgyzstan',
  'mail2la',
  'mail2lacrosse',
  'mail2lance',
  'mail2lao',
  'mail2larry',
  'mail2latvia',
  'mail2laugh',
  'mail2laura',
  'mail2lauren',
  'mail2laurie',
  'mail2lawrence',
  'mail2lawyer',
  'mail2lebanon',
  'mail2lee',
  'mail2leo',
  'mail2leon',
  'mail2leonard',
  'mail2leone',
  'mail2leslie',
  'mail2letter',
  'mail2liberia',
  'mail2libertarian',
  'mail2libra',
  'mail2libya',
  'mail2liechtenstein',
  'mail2life',
  'mail2linda',
  'mail2linux',
  'mail2lionel',
  'mail2lipstick',
  'mail2liquid',
  'mail2lisa',
  'mail2lithuania',
  'mail2litigator',
  'mail2liz',
  'mail2lloyd',
  'mail2lois',
  'mail2lola',
  'mail2london',
  'mail2looking',
  'mail2lori',
  'mail2lost',
  'mail2lou',
  'mail2louis',
  'mail2louisiana',
  'mail2lovable',
  'mail2love',
  'mail2lucky',
  'mail2lucy',
  'mail2lunch',
  'mail2lust',
  'mail2luxembourg',
  'mail2luxury',
  'mail2lyle',
  'mail2lynn',
  'mail2madagascar',
  'mail2madison',
  'mail2madrid',
  'mail2maggie',
  'mail2mail4',
  'mail2maine',
  'mail2malawi',
  'mail2malaysia',
  'mail2maldives',
  'mail2mali',
  'mail2malta',
  'mail2mambo',
  'mail2man',
  'mail2mandy',
  'mail2manhunter',
  'mail2mankind',
  'mail2many',
  'mail2marc',
  'mail2marcia',
  'mail2margaret',
  'mail2margie',
  'mail2marhaba',
  'mail2maria',
  'mail2marilyn',
  'mail2marines',
  'mail2mark',
  'mail2marriage',
  'mail2married',
  'mail2marries',
  'mail2mars',
  'mail2marsha',
  'mail2marshallislands',
  'mail2martha',
  'mail2martin',
  'mail2marty',
  'mail2marvin',
  'mail2mary',
  'mail2maryland',
  'mail2mason',
  'mail2massachusetts',
  'mail2matt',
  'mail2matthew',
  'mail2maurice',
  'mail2mauritania',
  'mail2mauritius',
  'mail2max',
  'mail2maxwell',
  'mail2maybe',
  'mail2mba',
  'mail2me4u',
  'mail2mechanic',
  'mail2medieval',
  'mail2megan',
  'mail2mel',
  'mail2melanie',
  'mail2melissa',
  'mail2melody',
  'mail2member',
  'mail2memphis',
  'mail2methodist',
  'mail2mexican',
  'mail2mexico',
  'mail2mgz',
  'mail2miami',
  'mail2michael',
  'mail2michelle',
  'mail2michigan',
  'mail2mike',
  'mail2milan',
  'mail2milano',
  'mail2mildred',
  'mail2milkyway',
  'mail2millennium',
  'mail2millionaire',
  'mail2milton',
  'mail2mime',
  'mail2mindreader',
  'mail2mini',
  'mail2minister',
  'mail2minneapolis',
  'mail2minnesota',
  'mail2miracle',
  'mail2missionary',
  'mail2mississippi',
  'mail2missouri',
  'mail2mitch',
  'mail2model',
  'mail2moldova',
  'mail2mom',
  'mail2monaco',
  'mail2money',
  'mail2mongolia',
  'mail2monica',
  'mail2montana',
  'mail2monty',
  'mail2moon',
  'mail2morocco',
  'mail2morpheus',
  'mail2mors',
  'mail2moscow',
  'mail2moslem',
  'mail2mouseketeer',
  'mail2movies',
  'mail2mozambique',
  'mail2mp3',
  'mail2mrright',
  'mail2msright',
  'mail2museum',
  'mail2music',
  'mail2musician',
  'mail2muslim',
  'mail2my',
  'mail2myboat',
  'mail2mycar',
  'mail2mycell',
  'mail2mygsm',
  'mail2mylaptop',
  'mail2mymac',
  'mail2mypager',
  'mail2mypalm',
  'mail2mypc',
  'mail2myphone',
  'mail2myplane',
  'mail2namibia',
  'mail2nancy',
  'mail2nasdaq',
  'mail2nathan',
  'mail2nauru',
  'mail2navy',
  'mail2neal',
  'mail2nebraska',
  'mail2ned',
  'mail2neil',
  'mail2nelson',
  'mail2nemesis',
  'mail2nepal',
  'mail2netherlands',
  'mail2network',
  'mail2nevada',
  'mail2newhampshire',
  'mail2newjersey',
  'mail2newmexico',
  'mail2newyork',
  'mail2newzealand',
  'mail2nicaragua',
  'mail2nick',
  'mail2nicole',
  'mail2niger',
  'mail2nigeria',
  'mail2nike',
  'mail2no',
  'mail2noah',
  'mail2noel',
  'mail2noelle',
  'mail2normal',
  'mail2norman',
  'mail2northamerica',
  'mail2northcarolina',
  'mail2northdakota',
  'mail2northpole',
  'mail2norway',
  'mail2notus',
  'mail2noway',
  'mail2nowhere',
  'mail2nuclear',
  'mail2nun',
  'mail2ny',
  'mail2oasis',
  'mail2oceanographer',
  'mail2ohio',
  'mail2ok',
  'mail2oklahoma',
  'mail2oliver',
  'mail2oman',
  'mail2one',
  'mail2onfire',
  'mail2online',
  'mail2oops',
  'mail2open',
  'mail2ophthalmologist',
  'mail2optometrist',
  'mail2oregon',
  'mail2oscars',
  'mail2oslo',
  'mail2painter',
  'mail2pakistan',
  'mail2palau',
  'mail2pan',
  'mail2panama',
  'mail2paraguay',
  'mail2paralegal',
  'mail2paris',
  'mail2park',
  'mail2parker',
  'mail2party',
  'mail2passion',
  'mail2pat',
  'mail2patricia',
  'mail2patrick',
  'mail2patty',
  'mail2paul',
  'mail2paula',
  'mail2pay',
  'mail2peace',
  'mail2pediatrician',
  'mail2peggy',
  'mail2pennsylvania',
  'mail2perry',
  'mail2persephone',
  'mail2persian',
  'mail2peru',
  'mail2pete',
  'mail2peter',
  'mail2pharmacist',
  'mail2phil',
  'mail2philippines',
  'mail2phoenix',
  'mail2phonecall',
  'mail2phyllis',
  'mail2pickup',
  'mail2pilot',
  'mail2pisces',
  'mail2planet',
  'mail2platinum',
  'mail2plato',
  'mail2pluto',
  'mail2pm',
  'mail2podiatrist',
  'mail2poet',
  'mail2poland',
  'mail2policeman',
  'mail2policewoman',
  'mail2politician',
  'mail2pop',
  'mail2pope',
  'mail2popular',
  'mail2portugal',
  'mail2poseidon',
  'mail2potatohead',
  'mail2power',
  'mail2presbyterian',
  'mail2president',
  'mail2priest',
  'mail2prince',
  'mail2princess',
  'mail2producer',
  'mail2professor',
  'mail2protect',
  'mail2psychiatrist',
  'mail2psycho',
  'mail2psychologist',
  'mail2qatar',
  'mail2queen',
  'mail2rabbi',
  'mail2race',
  'mail2racer',
  'mail2rachel',
  'mail2rage',
  'mail2rainmaker',
  'mail2ralph',
  'mail2randy',
  'mail2rap',
  'mail2rare',
  'mail2rave',
  'mail2ray',
  'mail2raymond',
  'mail2realtor',
  'mail2rebecca',
  'mail2recruiter',
  'mail2recycle',
  'mail2redhead',
  'mail2reed',
  'mail2reggie',
  'mail2register',
  'mail2rent',
  'mail2republican',
  'mail2resort',
  'mail2rex',
  'mail2rhodeisland',
  'mail2rich',
  'mail2richard',
  'mail2ricky',
  'mail2ride',
  'mail2riley',
  'mail2rita',
  'mail2rob',
  'mail2robert',
  'mail2roberta',
  'mail2robin',
  'mail2rock',
  'mail2rocker',
  'mail2rod',
  'mail2rodney',
  'mail2romania',
  'mail2rome',
  'mail2ron',
  'mail2ronald',
  'mail2ronnie',
  'mail2rose',
  'mail2rosie',
  'mail2roy',
  'mail2rss',
  'mail2rudy',
  'mail2rugby',
  'mail2runner',
  'mail2russell',
  'mail2russia',
  'mail2russian',
  'mail2rusty',
  'mail2ruth',
  'mail2rwanda',
  'mail2ryan',
  'mail2sa',
  'mail2sabrina',
  'mail2safe',
  'mail2sagittarius',
  'mail2sail',
  'mail2sailor',
  'mail2sal',
  'mail2salaam',
  'mail2sam',
  'mail2samantha',
  'mail2samoa',
  'mail2samurai',
  'mail2sandra',
  'mail2sandy',
  'mail2sanfrancisco',
  'mail2sanmarino',
  'mail2santa',
  'mail2sara',
  'mail2sarah',
  'mail2sat',
  'mail2saturn',
  'mail2saudi',
  'mail2saudiarabia',
  'mail2save',
  'mail2savings',
  'mail2school',
  'mail2scientist',
  'mail2scorpio',
  'mail2scott',
  'mail2sean',
  'mail2search',
  'mail2seattle',
  'mail2secretagent',
  'mail2senate',
  'mail2senegal',
  'mail2sensual',
  'mail2seth',
  'mail2sevenseas',
  'mail2sexy',
  'mail2seychelles',
  'mail2shane',
  'mail2sharon',
  'mail2shawn',
  'mail2ship',
  'mail2shirley',
  'mail2shoot',
  'mail2shuttle',
  'mail2sierraleone',
  'mail2simon',
  'mail2singapore',
  'mail2single',
  'mail2site',
  'mail2skater',
  'mail2skier',
  'mail2sky',
  'mail2sleek',
  'mail2slim',
  'mail2slovakia',
  'mail2slovenia',
  'mail2smile',
  'mail2smith',
  'mail2smooth',
  'mail2soccer',
  'mail2soccerfan',
  'mail2socialist',
  'mail2soldier',
  'mail2somalia',
  'mail2son',
  'mail2song',
  'mail2sos',
  'mail2sound',
  'mail2southafrica',
  'mail2southamerica',
  'mail2southcarolina',
  'mail2southdakota',
  'mail2southkorea',
  'mail2southpole',
  'mail2spain',
  'mail2spanish',
  'mail2spare',
  'mail2spectrum',
  'mail2splash',
  'mail2sponsor',
  'mail2sports',
  'mail2srilanka',
  'mail2stacy',
  'mail2stan',
  'mail2stanley',
  'mail2star',
  'mail2state',
  'mail2stephanie',
  'mail2steve',
  'mail2steven',
  'mail2stewart',
  'mail2stlouis',
  'mail2stock',
  'mail2stockholm',
  'mail2stockmarket',
  'mail2storage',
  'mail2store',
  'mail2strong',
  'mail2student',
  'mail2studio',
  'mail2studio54',
  'mail2stuntman',
  'mail2subscribe',
  'mail2sudan',
  'mail2superstar',
  'mail2surfer',
  'mail2suriname',
  'mail2susan',
  'mail2suzie',
  'mail2swaziland',
  'mail2sweden',
  'mail2sweetheart',
  'mail2swim',
  'mail2swimmer',
  'mail2swiss',
  'mail2switzerland',
  'mail2sydney',
  'mail2sylvia',
  'mail2syria',
  'mail2taboo',
  'mail2taiwan',
  'mail2tajikistan',
  'mail2tammy',
  'mail2tango',
  'mail2tanya',
  'mail2tanzania',
  'mail2tara',
  'mail2taurus',
  'mail2taxi',
  'mail2taxidermist',
  'mail2taylor',
  'mail2taz',
  'mail2teacher',
  'mail2technician',
  'mail2ted',
  'mail2telephone',
  'mail2teletubbie',
  'mail2tenderness',
  'mail2tennessee',
  'mail2tennis',
  'mail2tennisfan',
  'mail2terri',
  'mail2terry',
  'mail2test',
  'mail2texas',
  'mail2thailand',
  'mail2therapy',
  'mail2think',
  'mail2tickets',
  'mail2tiffany',
  'mail2tim',
  'mail2time',
  'mail2timothy',
  'mail2tina',
  'mail2titanic',
  'mail2toby',
  'mail2todd',
  'mail2togo',
  'mail2tom',
  'mail2tommy',
  'mail2tonga',
  'mail2tony',
  'mail2touch',
  'mail2tourist',
  'mail2tracey',
  'mail2tracy',
  'mail2tramp',
  'mail2travel',
  'mail2traveler',
  'mail2travis',
  'mail2trekkie',
  'mail2trex',
  'mail2triallawyer',
  'mail2trick',
  'mail2trillionaire',
  'mail2troy',
  'mail2truck',
  'mail2trump',
  'mail2try',
  'mail2tunisia',
  'mail2turbo',
  'mail2turkey',
  'mail2turkmenistan',
  'mail2tv',
  'mail2tycoon',
  'mail2tyler',
  'mail2u4me',
  'mail2uae',
  'mail2uganda',
  'mail2uk',
  'mail2ukraine',
  'mail2uncle',
  'mail2unsubscribe',
  'mail2uptown',
  'mail2uruguay',
  'mail2usa',
  'mail2utah',
  'mail2uzbekistan',
  'mail2v',
  'mail2vacation',
  'mail2valentines',
  'mail2valerie',
  'mail2valley',
  'mail2vamoose',
  'mail2vanessa',
  'mail2vanuatu',
  'mail2venezuela',
  'mail2venous',
  'mail2venus',
  'mail2vermont',
  'mail2vickie',
  'mail2victor',
  'mail2victoria',
  'mail2vienna',
  'mail2vietnam',
  'mail2vince',
  'mail2virginia',
  'mail2virgo',
  'mail2visionary',
  'mail2vodka',
  'mail2volleyball',
  'mail2waiter',
  'mail2wallstreet',
  'mail2wally',
  'mail2walter',
  'mail2warren',
  'mail2washington',
  'mail2wave',
  'mail2way',
  'mail2waycool',
  'mail2wayne',
  'mail2webmaster',
  'mail2webtop',
  'mail2webtv',
  'mail2weird',
  'mail2wendell',
  'mail2wendy',
  'mail2westend',
  'mail2westvirginia',
  'mail2whether',
  'mail2whip',
  'mail2white',
  'mail2whitehouse',
  'mail2whitney',
  'mail2why',
  'mail2wilbur',
  'mail2wild',
  'mail2willard',
  'mail2willie',
  'mail2wine',
  'mail2winner',
  'mail2wired',
  'mail2wisconsin',
  'mail2woman',
  'mail2wonder',
  'mail2world',
  'mail2worship',
  'mail2wow',
  'mail2www',
  'mail2wyoming',
  'mail2xfiles',
  'mail2xox',
  'mail2yachtclub',
  'mail2yahalla',
  'mail2yemen',
  'mail2yes',
  'mail2yugoslavia',
  'mail2zack',
  'mail2zambia',
  'mail2zenith',
  'mail2zephir',
  'mail2zeus',
  'mail2zipper',
  'mail2zoo',
  'mail2zoologist',
  'mail2zurich',
  'mail3000',
  'mail333',
  'mail4trash',
  'mail4u',
  'mailandftp',
  'mailandnews',
  'mailas',
  'mailasia',
  'mailbolt',
  'mailbomb',
  'mailboom',
  'mailbox',
  'mailbox72',
  'mailbox80',
  'mailbr',
  'mailc',
  'mailcan',
  'mailcat',
  'mailcc',
  'mailchoose',
  'mailcity',
  'mailclub',
  'maildrop',
  'maildx',
  'mailed',
  'mailexcite',
  'mailfa',
  'mailforce',
  'mailforspam',
  'mailfree',
  'mailfs',
  'mailftp',
  'mailgenie',
  'mailguard',
  'mailhaven',
  'mailhood',
  'mailimate',
  'mailinatar',
  'mailinator',
  'mailinblack',
  'mailingaddress',
  'mailingweb',
  'mailisent',
  'mailismagic',
  'mailite',
  'mailmate',
  'mailme',
  'mailme24',
  'mailmight',
  'mailmij',
  'mailnator',
  'mailnew',
  'mailops',
  'mailoye',
  'mailpanda',
  'mailpick',
  'mailpokemon',
  'mailpost',
  'mailpride',
  'mailproxsy',
  'mailpuppy',
  'mailquack',
  'mailrock',
  'mailroom',
  'mailru',
  'mailsac',
  'mailseal',
  'mailsent',
  'mailservice',
  'mailshuttle',
  'mailslapping',
  'mailstart',
  'mailstartplus',
  'mailsurf',
  'mailtag',
  'mailtemp',
  'mailto',
  'mailtothis',
  'mailueberfall',
  'mailup',
  'mailwire',
  'mailworks',
  'mailzi',
  'mailzilla',
  'maktoob',
  'malayalamtelevision',
  'maltesemail',
  'mamber',
  'manager',
  'mancity',
  'mantrafreenet',
  'mantramail',
  'mantraonline',
  'manybrain',
  'marchmail',
  'mariahc',
  'marijuana',
  'married-not',
  'marsattack',
  'martindalemail',
  'mash4077',
  'masrawy',
  'matmail',
  'mauimail',
  'mauritius',
  'maxleft',
  'maxmail',
  'mbox',
  'mchsi',
  'me-mail',
  'me',
  'medical',
  'medscape',
  'meetingmall',
  'megago',
  'megamail',
  'megapoint',
  'mehrani',
  'mehtaweb',
  'meine-dateien',
  'meine-diashow',
  'meine-fotos',
  'meine-urlaubsfotos',
  'mekhong',
  'melodymail',
  'meloo',
  'merda',
  'message',
  'messages',
  'metacrawler',
  'metalfan',
  'metaping',
  'metta',
  'mexicomail',
  'mezimages',
  'mfsa',
  'mierdamail',
  'miesto',
  'mighty',
  'migmail',
  'migumail',
  'miho-nakayama',
  'mikrotamanet',
  'millionaireintraining',
  'millionairemail',
  'milmail',
  'mindless',
  'mindspring',
  'minister',
  'misery',
  'mittalweb',
  'mixmail',
  'mjfrogmail',
  'ml1',
  'mlb',
  'mm',
  'mns',
  'moakt',
  'mobilbatam',
  'mobileninja',
  'mochamail',
  'mohammed',
  'mohmal',
  'moldova',
  'moldovacc',
  'momslife',
  'monemail',
  'money',
  'montevideo',
  'monumentmail',
  'moonman',
  'moose-mail',
  'mor19',
  'mortaza',
  'mosaicfx',
  'moscowmail',
  'most-wanted',
  'mostlysunny',
  'motormania',
  'movemail',
  'movieluver',
  'mox',
  'mp4',
  'mr-potatohead',
  'mscold',
  'msgbox',
  'msn',
  'mt2015',
  'mt2016',
  'mttestdriver',
  'muehlacker',
  'muell',
  'muellmail',
  'muellemail',
  'mundomail',
  'munich',
  'music',
  'musician',
  'musicscene',
  'muskelshirt',
  'muslim',
  'muslimsonline',
  'mutantweb',
  'mvrht',
  'my',
  'my10minutemail',
  'mybox',
  'mycabin',
  'mycity',
  'mycool',
  'mydomain',
  'mydotcomaddress',
  'myfamily',
  'myfastmail',
  'mygo',
  'myiris',
  'mymacmail',
  'mynamedot',
  'mynet',
  'mynetaddress',
  'mynetstore',
  'myownemail',
  'myownfriends',
  'mypacks',
  'mypad',
  'mypersonalemail',
  'myplace',
  'myrambler',
  'myrealbox',
  'myremarq',
  'myself',
  'myspaceinc',
  'myspamless',
  'mystupidjob',
  'mytemp',
  'mythirdage',
  'myway',
  'myworldmail',
  'n2',
  'n2baseball',
  'n2business',
  'n2mail',
  'n2soccer',
  'n2software',
  'nabc',
  'nafe',
  'nagpal',
  'nakedgreens',
  'name',
  'nameplanet',
  'nandomail',
  'naplesnews',
  'naseej',
  'nativestar',
  'nativeweb',
  'naui',
  'naver',
  'navigator',
  'navy',
  'naz',
  'nc',
  'nchoicemail',
  'neeva',
  'nemra1',
  'nenter',
  'neo',
  'nervhq',
  'net-c',
  'net-pager',
  'net-shopping',
  'net4b',
  'net4you',
  'netbounce',
  'netbroadcaster',
  'netby',
  'netc',
  'netcenter-vn',
  'netcmail',
  'netcourrier',
  'netexecutive',
  'netexpressway',
  'netgenie',
  'netian',
  'netizen',
  'netlane',
  'netlimit',
  'netmongol',
  'netnet',
  'netnoir',
  'netpiper',
  'netposta',
  'netralink',
  'netscape',
  'netscapeonline',
  'netspace',
  'netspeedway',
  'netsquare',
  'netster',
  'nettaxi',
  'nettemail',
  'netterchef',
  'netti',
  'netzero',
  'netzidiot',
  'neue-dateien',
  'neuro',
  'newmail',
  'newsboysmail',
  'newyork',
  'nextmail',
  'nexxmail',
  'nfmail',
  'nicebush',
  'nicegal',
  'nicholastse',
  'nicolastse',
  'nightmail',
  'nikopage',
  'nimail',
  'ninfan',
  'nirvanafan',
  'nmail',
  'noavar',
  'nonpartisan',
  'nonspam',
  'nonspammer',
  'norika-fujiwara',
  'norikomail',
  'northgates',
  'nospammail',
  'nospamthanks',
  'nowhere',
  'ntelos',
  'ntlhelp',
  'ntlworld',
  'ntscan',
  'null',
  'nullbox',
  'nur-fuer-spam',
  'nus',
  'nwldx',
  'nwytg',
  'nxt',
  'ny',
  'nybella',
  'nyc',
  'nycmail',
  'nzoomail',
  'o-tay',
  'o2',
  'oaklandas-fan',
  'oath',
  'oceanfree',
  'odaymail',
  'oddpost',
  'odmail',
  'office-dateien',
  'office-email',
  'offroadwarrior',
  'oicexchange',
  'oida',
  'oikrach',
  'okbank',
  'okhuman',
  'okmad',
  'okmagic',
  'okname',
  'okuk',
  'oldies104mail',
  'ole',
  'olemail',
  'olympist',
  'olypmall',
  'omaninfo',
  'omen',
  'onebox',
  'onenet',
  'oneoffmail',
  'onet',
  'oninet',
  'online',
  'onlinewiz',
  'onmilwaukee',
  'onobox',
  'op',
  'opayq',
  'openmailbox',
  'operafan',
  'operamail',
  'opoczta',
  'optician',
  'optonline',
  'optusnet',
  'orange',
  'orbitel',
  'orgmail',
  'orthodontist',
  'osite',
  'oso',
  'otakumail',
  'our-computer',
  'our-office',
  'our',
  'ourbrisbane',
  'ourklips',
  'ournet',
  'outgun',
  'outlawspam',
  'outlook',
  'over-the-rainbow',
  'ownmail',
  'ozbytes',
  'ozemail',
  'pacbell',
  'pacific-ocean',
  'pacific-re',
  'pacificwest',
  'packersfan',
  'pagina',
  'pagons',
  'pakistanmail',
  'pakistanoye',
  'palestinemail',
  'pandora',
  'papierkorb',
  'parkjiyoon',
  'parsmail',
  'partlycloudy',
  'partybombe',
  'partyheld',
  'partynight',
  'parvazi',
  'passwordmail',
  'pathfindermail',
  'pconnections',
  'pcpostal',
  'pcsrock',
  'pcusers',
  'pediatrician',
  'penpen',
  'peoplepc',
  'peopleweb',
  'pepbot',
  'perfectmail',
  'perso',
  'personal',
  'personales',
  'petlover',
  'petml',
  'pettypool',
  'pezeshkpour',
  'pfui',
  'phayze',
  'phone',
  'photo-impact',
  'photographer',
  'phpbb',
  'phreaker',
  'phus8kajuspa',
  'physicist',
  'pianomail',
  'pickupman',
  'picusnet',
  'pigpig',
  'pinoymail',
  'piracha',
  'pisem',
  'pjjkp',
  'planet',
  'planetaccess',
  'planetarymotion',
  'planetearthinter',
  'planetmail',
  'planetout',
  'plasa',
  'playersodds',
  'playful',
  'playstation',
  'plus',
  'plusmail',
  'pmail',
  'pobox',
  'pochta',
  'poczta',
  'poetic',
  'pokemail',
  'pokemonpost',
  'pokepost',
  'polandmail',
  'polbox',
  'policeoffice',
  'politician',
  'polizisten-duzer',
  'polyfaust',
  'pool-sharks',
  'poond',
  'popaccount',
  'popmail',
  'popsmail',
  'popstar',
  'portugalmail',
  'portugalnet',
  'positive-thinking',
  'post',
  'posta',
  'postaccesslite',
  'postafree',
  'postaweb',
  'postfach',
  'postinbox',
  'postino',
  'postmark',
  'postmaster',
  'postpro',
  'pousa',
  'powerfan',
  'pp',
  'praize',
  'premium-mail',
  'premiumservice',
  'presidency',
  'press',
  'priest',
  'primposta',
  'privy-mail',
  'privymail',
  'pro',
  'probemail',
  'prodigy',
  'progetplus',
  'programist',
  'programmer',
  'programozo',
  'proinbox',
  'project2k',
  'promessage',
  'prontomail',
  'protestant',
  'protonmail',
  'prydirect',
  'psv-supporter',
  'ptd',
  'public-files',
  'public',
  'publicist',
  'pulp-fiction',
  'punkass',
  'purpleturtle',
  'put2',
  'pwrby',
  'q',
  'qatarmail',
  'qmail',
  'qprfans',
  'qq',
  'qrio',
  'quackquack',
  'quakemail',
  'qualityservice',
  'quantentunnel',
  'qudsmail',
  'quepasa',
  'quickhosts',
  'quickmail',
  'quicknet',
  'quickwebmail',
  'quiklinks',
  'quikmail',
  'qv7',
  'qwest',
  'qwestoffice',
  'r-o-o-t',
  'raakim',
  'racedriver',
  'racefanz',
  'racingfan',
  'racingmail',
  'radicalz',
  'radiku',
  'radiologist',
  'ragingbull',
  'ralib',
  'rambler',
  'ranmamail',
  'rastogi',
  'ratt-n-roll',
  'rattle-snake',
  'raubtierbaendiger',
  'ravearena',
  'ravemail',
  'razormail',
  'rccgmail',
  'rcn',
  'realemail',
  'reality-concept',
  'reallyfast',
  'reallymymail',
  'realradiomail',
  'realtyagent',
  'reborn',
  'reconmail',
  'recycler',
  'recyclermail',
  'rediff',
  'rediffmail',
  'rediffmailpro',
  'rednecks',
  'redseven',
  'redsfans',
  'regbypass',
  'reggaefan',
  'registerednurses',
  'regspaces',
  'reincarnate',
  'religious',
  'remail',
  'renren',
  'repairman',
  'reply',
  'representative',
  'rescueteam',
  'resgedvgfed',
  'resource',
  'resumemail',
  'rezai',
  'rhyta',
  'richmondhill',
  'rickymail',
  'rin',
  'riopreto',
  'rklips',
  'rn',
  'ro',
  'roadrunner',
  'roanokemail',
  'rock',
  'rocketmail',
  'rocketship',
  'rockfan',
  'rodrun',
  'rogers',
  'rome',
  'roosh',
  'rootprompt',
  'roughnet',
  'royal',
  'rr',
  'rrohio',
  'rsub',
  'rubyridge',
  'runbox',
  'rushpost',
  'ruttolibero',
  'rvshop',
  's-mail',
  'sabreshockey',
  'sacbeemail',
  'saeuferleber',
  'safe-mail',
  'safrica',
  'sagra',
  'sags-per-mail',
  'sailormoon',
  'saintly',
  'saintmail',
  'sale-sale-sale',
  'salehi',
  'salesperson',
  'samerica',
  'samilan',
  'sammimail',
  'sandelf',
  'sanfranmail',
  'sanook',
  'sapo',
  'saudia',
  'savelife',
  'sayhi',
  'saynotospams',
  'sbcglbal',
  'sbcglobal',
  'scandalmail',
  'scarlet',
  'schafmail',
  'schizo',
  'schmusemail',
  'schoolemail',
  'schoolmail',
  'schoolsucks',
  'schreib-doch-mal-wieder',
  'schweiz',
  'sci',
  'scientist',
  'scifianime',
  'scotland',
  'scotlandmail',
  'scottishmail',
  'scottsboro',
  'scubadiving',
  'seanet',
  'search',
  'searchwales',
  'sebil',
  'seckinmail',
  'secret-police',
  'secretary',
  'secretservices',
  'secure-mail',
  'seductive',
  'seekstoyboy',
  'seguros',
  'selfdestructingmail',
  'send',
  'sendme',
  'sendspamhere',
  'sent',
  'sentrismail',
  'serga',
  'servemymail',
  'servermaps',
  'sesmail',
  'sexmagnet',
  'seznam',
  'shahweb',
  'shaniastuff',
  'shared-files',
  'sharedmailbox',
  'sharmaweb',
  'shaw',
  'she',
  'shieldedmail',
  'shinedyoureyes',
  'shitaway',
  'shitmail',
  'shitware',
  'shockinmytown',
  'shootmail',
  'shortmail',
  'shotgun',
  'showslow',
  'shuf',
  'sialkotcity',
  'sialkotian',
  'sialkotoye',
  'sify',
  'silkroad',
  'sina',
  'sinamail',
  'singapore',
  'singles4jesus',
  'singmail',
  'singnet',
  'sinnlos-mail',
  'siteposter',
  'skafan',
  'skeefmail',
  'skim',
  'skizo',
  'skrx',
  'sky',
  'skynet',
  'slamdunkfan',
  'slave-auctions',
  'slingshot',
  'slippery',
  'slipry',
  'slo',
  'slotter',
  'smap',
  'smapxsmap',
  'smashmail',
  'smellrear',
  'smileyface',
  'smoothmail',
  'sms',
  'snail-mail',
  'snakebite',
  'snakemail',
  'sndt',
  'sneakemail',
  'snet',
  'sniper',
  'snkmail',
  'snoopymail',
  'snowboarding',
  'snowdonia',
  'socamail',
  'socceramerica',
  'soccermail',
  'soccermomz',
  'social-mailer',
  'socialworker',
  'sociologist',
  'sofort-mail',
  'sofortmail',
  'softhome',
  'sogou',
  'sohu',
  'sol',
  'solar-impact',
  'solcon',
  'soldier',
  'solution4u',
  'solvemail',
  'songwriter',
  'sonnenkinder',
  'soodomail',
  'soon',
  'soulfoodcookbook',
  'sp',
  'space-bank',
  'space-man',
  'space-ship',
  'space-travel',
  'space',
  'spacemart',
  'spacetowns',
  'spacewar',
  'spainmail',
  'spam',
  'spamavert',
  'spambob',
  'spambog',
  'spambooger',
  'spamcero',
  'spamdecoy',
  'spameater',
  'spamex',
  'spamfree24',
  'spamgoes',
  'spaminator',
  'spamkill',
  'spaml',
  'spamoff',
  'spamstack',
  'spartapiet',
  'spazmail',
  'speedemail',
  'speedpost',
  'speedrules',
  'speedrulz',
  'speedymail',
  'sperke',
  'spils',
  'spinfinder',
  'spl',
  'spoko',
  'spoofmail',
  'sportemail',
  'sportsmail',
  'sporttruckdriver',
  'spray',
  'spybox',
  'spymac',
  'sraka',
  'srilankan',
  'ssl-mail',
  'st-davids',
  'stade',
  'stalag13',
  'stargateradio',
  'starmail',
  'starmedia',
  'starplace',
  'starspath',
  'start',
  'startkeys',
  'stinkefinger',
  'stipte',
  'stoned',
  'stones',
  'stop-my-spam',
  'stopdropandroll',
  'storksite',
  'streber24',
  'streetwisemail',
  'stribmail',
  'strompost',
  'strongguy',
  'student',
  'studentcenter',
  'stuffmail',
  'subram',
  'sudanmail',
  'sudolife',
  'sudomail',
  'sudoverse',
  'sudoweb',
  'sudoworld',
  'suhabi',
  'suisse',
  'sukhumvit',
  'sunpoint',
  'sunrise-sunset',
  'sunsgame',
  'sunumail',
  'suomi24',
  'superdada',
  'supereva',
  'supermail',
  'superrito',
  'superstachel',
  'surat',
  'surf3',
  'surfree',
  'surfy',
  'surgical',
  'surimail',
  'survivormail',
  'susi',
  'svk',
  'swbell',
  'sweb',
  'swedenmail',
  'sweetville',
  'sweetxxx',
  'swift-mail',
  'swiftdesk',
  'swingeasyhithard',
  'swingfan',
  'swipermail',
  'swirve',
  'swissinfo',
  'swissmail',
  'switchboardmail',
  'switzerland',
  'sx172',
  'syom',
  'syriamail',
  't-online',
  't',
  't2mail',
  'tafmail',
  'takuyakimura',
  'talk21',
  'talkcity',
  'talkinator',
  'tamil',
  'tampabay',
  'tankpolice',
  'tatanova',
  'tbwt',
  'tcc',
  'tds',
  'teachermail',
  'teachers',
  'teamdiscovery',
  'teamtulsa',
  'tech-center',
  'tech4peace',
  'techemail',
  'techie',
  'technisamail',
  'technologist',
  'techscout',
  'techspot',
  'teenagedirtbag',
  'tele2',
  'telebot',
  'telefonica',
  'teleline',
  'telenet',
  'telepac',
  'telerymd',
  'teleworm',
  'telfort',
  'telfortglasvezel',
  'telinco',
  'telkom',
  'telpage',
  'telstra',
  'temp-mail',
  'temp',
  'tempail',
  'tempemail',
  'tempmail',
  'tempmail2',
  'tempmaildemo',
  'tempmailer',
  'temporarioemail',
  'temporaryemail',
  'tempthe',
  'tempymail',
  'temtulsa',
  'tenchiclub',
  'tenderkiss',
  'tennismail',
  'terminverpennt',
  'terra',
  'test',
  'tfanus',
  'tfz',
  'thai',
  'thaimail',
  'thanksnospam',
  'the-african',
  'the-airforce',
  'the-aliens',
  'the-american',
  'the-animal',
  'the-army',
  'the-astronaut',
  'the-beauty',
  'the-big-apple',
  'the-biker',
  'the-boss',
  'the-brazilian',
  'the-canadian',
  'the-canuck',
  'the-captain',
  'the-chinese',
  'the-country',
  'the-cowboy',
  'the-davis-home',
  'the-dutchman',
  'the-eagles',
  'the-englishman',
  'the-fastest',
  'the-fool',
  'the-frenchman',
  'the-galaxy',
  'the-genius',
  'the-gentleman',
  'the-german',
  'the-gremlin',
  'the-hooligan',
  'the-italian',
  'the-japanese',
  'the-lair',
  'the-madman',
  'the-mailinglist',
  'the-marine',
  'the-master',
  'the-mexican',
  'the-ministry',
  'the-monkey',
  'the-newsletter',
  'the-pentagon',
  'the-police',
  'the-prayer',
  'the-professional',
  'the-quickest',
  'the-russian',
  'the-snake',
  'the-spaceman',
  'the-stock-market',
  'the-student',
  'the-whitehouse',
  'the-wild-west',
  'the18th',
  'thecoolguy',
  'thecriminals',
  'thedoghousemail',
  'thedorm',
  'theend',
  'theglobe',
  'thegolfcourse',
  'thegooner',
  'theheadoffice',
  'theinternetemail',
  'thelanddownunder',
  'themail',
  'themillionare',
  'theoffice',
  'theplate',
  'thepokerface',
  'thepostmaster',
  'theraces',
  'theracetrack',
  'therapist',
  'thestreetfighter',
  'theteebox',
  'thewatercooler',
  'thewebpros',
  'thewizzard',
  'thewizzkid',
  'thezhangs',
  'thirdage',
  'thisgirl',
  'thraml',
  'throwam',
  'thundermail',
  'tidni',
  'timein',
  'tiscali',
  'tkcity',
  'tmail',
  'toast',
  'toke',
  'tom',
  'toolsource',
  'toomail',
  'toothfairy',
  'topchat',
  'topgamers',
  'topletter',
  'topmail-files',
  'topmail',
  'topsurf',
  'torchmail',
  'torontomail',
  'tortenboxer',
  'totalmail',
  'totalmusic',
  'townisp',
  'tpg',
  'trash-amil',
  'trash-mail',
  'trash2010',
  'trash2011',
  'trashdevil',
  'trashymail',
  'travel',
  'trayna',
  'trialbytrivia',
  'trickmail',
  'trimix',
  'tritium',
  'trmailbox',
  'tropicalstorm',
  'truckerz',
  'truckracer',
  'truckracers',
  'trust-me',
  'truthmail',
  'tsamail',
  'ttml',
  'tunisiamail',
  'turboprinz',
  'turboprinzessin',
  'turkey',
  'turual',
  'tut',
  'tvstar',
  'twc',
  'twcny',
  'twinstarsmail',
  'tx',
  'tycoonmail',
  'typemail',
  'u14269',
  'u2club',
  'ua',
  'uae',
  'uaemail',
  'ubbi',
  'uboot',
  'uk2',
  'uk2k',
  'uk2net',
  'uk7',
  'uk8',
  'ukbuilder',
  'ukcool',
  'ukdreamcast',
  'ukmail',
  'ukmax',
  'ukr',
  'uku',
  'ultra',
  'ultapulta',
  'ultrapostman',
  'ummah',
  'umpire',
  'unbounded',
  'unforgettable',
  'uni',
  'unican',
  'unihome',
  'unitybox',
  'universal',
  'uno',
  'unofree',
  'unterderbruecke',
  'uol',
  'uole',
  'uolmail',
  'uomail',
  'upc',
  'upcmail',
  'upf',
  'uplipht',
  'ureach',
  'urgentmail',
  'urhen',
  'uroid',
  'usa',
  'usaaccess',
  'usanetmail',
  'used-product',
  'usermail',
  'username',
  'usma',
  'usmc',
  'uswestmail',
  'uymail',
  'uyuyuy',
  'v-sexi',
  'vaasfc4',
  'vahoo',
  'valemail',
  'vampirehunter',
  'varbizmail',
  'vcmail',
  'velnet',
  'velocall',
  'verizon',
  'verizonmail',
  'verlass-mich-nicht',
  'versatel',
  'veryfast',
  'veryrealemail',
  'veryspeedy',
  'vfemail',
  'vickaentb',
  'videotron',
  'viditag',
  'viewcastmedia',
  'vinbazar',
  'violinmakers',
  'vip',
  'vipmail',
  'virgilio',
  'virgin',
  'virginbroadband',
  'virginmedia',
  'virtualmail',
  'visitmail',
  'visitweb',
  'visto',
  'visualcities',
  'vivavelocity',
  'vivianhsu',
  'vjtimail',
  'vkcode',
  'vnet',
  'vnn',
  'vodafone',
  'vodafonethuis',
  'volcanomail',
  'vollbio',
  'volloeko',
  'vomoto',
  'vorsicht-bissig',
  'vorsicht-scharf',
  'vote-democrats',
  'vote-hillary',
  'vote-republicans',
  'vote4gop',
  'votenet',
  'vp',
  'vr9',
  'vubby',
  'w3',
  'wahoye',
  'walala',
  'wales2000',
  'walkmail',
  'wam',
  'wanadoo',
  'war-im-urlaub',
  'warmmail',
  'warpmail',
  'warrior',
  'waumail',
  'wazabi',
  'wbdet',
  'wearab',
  'web-contact',
  'web-emailbox',
  'web-ideal',
  'web-mail',
  'web-police',
  'web',
  'webave',
  'webcammail',
  'webcity',
  'webcontact-france',
  'webdream',
  'webindia123',
  'webjump',
  'webm4il',
  'webmail',
  'webmails',
  'webname',
  'webprogramming',
  'webstation',
  'websurfer',
  'webtopmail',
  'webuser',
  'wee',
  'weedmail',
  'weekmail',
  'weekonline',
  'wefjo',
  'weg-werf-email',
  'wegas',
  'wegwerf-emails',
  'wegwerfmail',
  'wegwerpmailadres',
  'wehshee',
  'weibsvolk',
  'weinenvorglueck',
  'welsh-lady',
  'westnet',
  'wetrainbayarea',
  'wfgdfhj',
  'whale-mail',
  'whartontx',
  'whatiaas',
  'whatpaas',
  'wheelweb',
  'whipmail',
  'whoever',
  'whoopymail',
  'whtjddn',
  'wickmail',
  'wideopenwest',
  'wildmail',
  'wilemail',
  'will-hier-weg',
  'windowslive',
  'windrivers',
  'windstream',
  'wingnutz',
  'winmail',
  'winning',
  'wir-haben-nachwuchs',
  'wir-sind-cool',
  'wirsindcool',
  'witty',
  'wiz',
  'wkbwmail',
  'wmail',
  'wo',
  'woh',
  'wolf-web',
  'wolke7',
  'wollan',
  'wombles',
  'women-at-work',
  'wongfaye',
  'wooow',
  'worker',
  'workmail',
  'worldemail',
  'worldnet',
  'wormseo',
  'wosaddict',
  'wouldilie',
  'wovz',
  'wowgirl',
  'wowmail',
  'wowway',
  'wp',
  'wptamail',
  'wrexham',
  'writeme',
  'writemeback',
  'wrongmail',
  'wtvhmail',
  'wwdg',
  'www',
  'www2000',
  'wx88',
  'wxs',
  'x-mail',
  'x-networks',
  'x5g',
  'xagloo',
  'xaker',
  'xing886',
  'xmastime',
  'xms',
  'xmsg',
  'xoom',
  'xoxox',
  'xpressmail',
  'xs4all',
  'xsecurity',
  'xsmail',
  'xtra',
  'xuno',
  'xww',
  'xy9ce',
  'xyzfree',
  'xzapmail',
  'y7mail',
  'ya',
  'yada-yada',
  'yaho',
  'yahoo',
  'yahoofs',
  'yalla',
  'yalook',
  'yam',
  'yandex',
  'yapost',
  'yapped',
  'yawmail',
  'yeah',
  'yebox',
  'yehey',
  'yemenmail',
  'yepmail',
  'yert',
  'yesey',
  'yifan',
  'ymail',
  'yogotemail',
  'yomail',
  'yopmail',
  'yopolis',
  'yopweb',
  'youareadork',
  'youmailr',
  'your-house',
  'your-mail',
  'yourinbox',
  'yourlifesucks',
  'yourlover',
  'yourname',
  'yournightmare',
  'yours',
  'yourssincerely',
  'yoursubdomain',
  'yourteacher',
  'yourwap',
  'yuuhuu',
  'yyhmail',
  'z1p',
  'za',
  'zahadum',
  'zaktouni',
  'zeepost',
  'zetmail',
  'zhaowei',
  'zhouemail',
  'ziggo',
  'zionweb',
  'zip',
  'zipido',
  'ziplip',
  'zipmail',
  'zipmax',
  'zmail',
  'zoemail',
  'zoho',
  'zomg',
  'zonnet',
  'zoominternet',
  'zubee',
  'zuvio',
  'zuzzurello',
  'zwallet',
  'zweb',
  'zxcv',
  'zxcvbnm',
  'zybermail',
  'zydecofan',
  'zzn',
  'zzom',
  'zzz',

  // Manually added
  'awdrt'
])